module.exports = __webpack_public_path__ + "img/Motor_mob_4.5998232b.jpg";